import { Component, type ReactNode } from 'react';

interface Props { children: ReactNode; label?: string }
interface State { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  componentDidCatch(error: Error, info: { componentStack?: string }): void {
    // eslint-disable-next-line no-console
    console.error(`[ErrorBoundary${this.props.label ? ' '+this.props.label : ''}]`, error, info);
  }
  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="overlay" onClick={() => { this.setState({ error: null }); window.location.hash = ''; }}>
          <div className="overlay-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 720 }}>
            <div className="topbar-brand" style={{ color: 'var(--danger)' }}>Error</div>
            <h2 style={{ margin: '4px 0 16px', fontSize: 18 }}>{this.props.label ?? 'Algo falló al renderizar'}</h2>
            <pre style={{
              background: 'var(--surface-hi)', padding: 12, borderRadius: 6,
              fontSize: 11, color: 'var(--fg)', overflow: 'auto', maxHeight: 280,
              whiteSpace: 'pre-wrap', wordBreak: 'break-word',
            }}>{this.state.error.message}
{this.state.error.stack?.slice(0, 1200)}</pre>
            {/* React recuerda una carga fallida de una pantalla y no la reintenta: solo recargar la arregla. */}
            <button className="tab" style={{ marginTop: 12, marginRight: 8 }} onClick={() => window.location.reload()}>
              Recargar la página
            </button>
            <button className="tab" style={{ marginTop: 12 }} onClick={() => { this.setState({ error: null }); window.location.hash = ''; }}>
              ✕ Cerrar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
